import React, { useEffect, useState } from 'react';
import { formatCurrency, getAlert, parseCurrency, useEscapeClose } from '../../../utils/SamuiUtils';
import { manageItemRemainData } from '../../../utils/RemainUtils';

function EditRemainModal({ isOpen, onClose, item, initialize }) {
    const [adjustAmount, setAdjustAmount] = useState("0.00");
    const [paymentType, setPaymentType] = useState(""); // "debt" | "none" | "over"

    useEscapeClose(isOpen, onClose);

    useEffect(() => {
        setAdjustAmount("0.00");
        setPaymentType("");
    }, [isOpen]);

    const handleSubmit = async () => {
        try {
            if (!/^-?\d{1,3}(,\d{3})*(\.\d+)?$|^-?\d+(\.\d+)?$/.test(adjustAmount)) return getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");

            if (paymentType === "") {
                return getAlert("FAILED", "กรุณาเลือกประเภทการคืนถัง");
            }

            // เช็กการกรอกจำนวนที่จะปรับปรุงก่อน
            if (!adjustAmount && isNaN(Number(adjustAmount))) return getAlert("FAILED", "กรุณากรอกจำนวนที่ต้องการปรับปรุง");

            // IF => ยอดเป็น + เช่น 200 ก็ต้องไปปรับก่อน -200 จะได้ยอดค้างชำระ = 0  
            // ELSE IF => ยอดเป็น - เช่น -200 ก็ต้องไป ปรับ ก่อน +200 จะได้ยอดค้างชำระ = 0  
            // ELSE => ยอดเป็น 0.00 ก็ไม่ต้องทำอะไร

            if (item.Item_Onhand > 0) {
                await manageItemRemainData(
                    item.AR_Id, // AR_ID ของลูกค้านั้นๆ
                    item.AR_Code, // AR_Code ของลูกค้านั้นๆ
                    item.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                    0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                    "AO", // ประเภท เช่น AI/AO
                    parseCurrency(item.Item_Onhand), // ค่าจำนวนเงิน
                    null, // ไอดีเอกสาร
                    "ปรับปรุงออก", // เลขเอกสาร
                    null, // เลขเอกสารอ้างอิง
                    "ปรับยอดค้างถัง" // หมายเหตุ
                );
            } else if (item.Item_Onhand < 0) {
                await manageItemRemainData(
                    item.AR_Id, // AR_ID ของลูกค้านั้นๆ
                    item.AR_Code, // AR_Code ของลูกค้านั้นๆ
                    item.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                    0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                    "AI", // ประเภท เช่น AI/AO
                    parseCurrency(Math.abs(item.Item_Onhand)), // ค่าจำนวนเงิน
                    null, // ไอดีเอกสาร
                    "ปรับปรุงเข้า", // เลขเอกสาร
                    null, // เลขเอกสารอ้างอิง
                    "ปรับยอดค้างถัง" // หมายเหตุ
                );
            } else {
                // ยอดเป็น 0.00 ก็ไม่ต้องทำอะไร
            }

            // IF => ถ้ายอดมากกว่า 0 ให้ ปรับ ยอดใน Input Text เข้าไป   
            // ELSE IF => แต่ถ้ายอด = 0 ไม่ต้องทำอะไร ก็ ปรับ ออก   
            // ELSE IF => ยอดน้อยกว่า 0 ให้ ปรับ ยอดใน Input Text เข้าไป    
            // ELSE => ERROR

            if (paymentType === "debt") {
                await manageItemRemainData(
                    item.AR_Id, // AR_ID ของลูกค้านั้นๆ
                    item.AR_Code, // AR_Code ของลูกค้านั้นๆ
                    item.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                    0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                    "AO", // ประเภท เช่น AI/AO
                    -parseCurrency(adjustAmount), // ค่าจำนวนเงิน
                    null, // ไอดีเอกสาร
                    "ปรับปรุงออก", // เลขเอกสาร
                    null, // เลขเอกสารอ้างอิง
                    "ปรับยอดค้างถัง" // หมายเหตุ
                );
            } else if (paymentType === "none") {
                await manageItemRemainData(
                    item.AR_Id, // AR_ID ของลูกค้านั้นๆ
                    item.AR_Code, // AR_Code ของลูกค้านั้นๆ
                    item.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                    0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                    "AO", // ประเภท เช่น AI/AO
                    parseCurrency("0.00"), // ค่าจำนวนเงิน
                    null, // ไอดีเอกสาร
                    "ปรับปรุงออก", // เลขเอกสาร
                    null, // เลขเอกสารอ้างอิง
                    "ปรับยอดค้างถัง" // หมายเหตุ
                );
            } else if (paymentType === "over") {
                await manageItemRemainData(
                    item.AR_Id, // AR_ID ของลูกค้านั้นๆ
                    item.AR_Code, // AR_Code ของลูกค้านั้นๆ
                    item.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                    0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                    "AI", // ประเภท เช่น AI/AO
                    parseCurrency(adjustAmount), // ค่าจำนวนเงิน
                    null, // ไอดีเอกสาร
                    "ปรับปรุงเข้า", // เลขเอกสาร
                    null, // เลขเอกสารอ้างอิง
                    "ปรับยอดค้างถัง" // หมายเหตุ
                );
            } else {
                getAlert("FAILED", "พบข้อผิดพลาดในการปรับปรุงยอดค้างถัง");
            }

            setAdjustAmount("0.00");
            setPaymentType("");
            onClose();
            initialize();
        } catch (error) {
            getAlert("FAILED", error);
        }
    };

    if (!isOpen || !item) return null;

    return (
        <div className={`modal ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header bg-warning text-white">
                        <h4 className="modal-title">ปรับปรุงยอดค้างถัง</h4>
                        <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                    </div>

                    <div className="modal-body py-4 px-4">
                        <div className="text-center mb-4">
                            <div className="fs-3 fw-bold">{item.AR_Name}</div>
                        </div>

                        <div className="text-center mb-3">
                            <div className="fs-6 text-muted">ยอดค้างถังปัจจุบัน</div>
                            <div className="fs-2 fw-bold" style={{ color: item.Item_Onhand < 0 ? '#dc3545' : '#28a745' }}>
                                {formatCurrency(item.Item_Onhand)}
                            </div>
                        </div>

                        {/* ปุ่มประเภท */}
                        <div className="d-flex justify-content-center gap-2 mb-4 flex-wrap">
                            <button className={`btn ${paymentType === 'debt' ? 'btn-danger' : 'btn-outline-danger'}`} onClick={() => setPaymentType('debt')}>ค้างถัง</button>
                            <button className={`btn ${paymentType === 'none' ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => {
                                setPaymentType('none');
                                setAdjustAmount("0.00");
                            }}>ไม่ค้างถัง</button>
                            <button className={`btn ${paymentType === 'over' ? 'btn-success' : 'btn-outline-success'}`} onClick={() => setPaymentType('over')}>ถังเกิน</button>
                        </div>

                        {/* ช่องกรอก */}
                        {(paymentType === "debt" || paymentType === "over") && (
                            <div className="mb-3 text-center">
                                <label className="form-label fw-semibold mb-2">จำนวนที่ต้องการปรับ (ถัง)</label>
                                <div className="d-flex justify-content-center">
                                    <input
                                        type="text"
                                        className="form-control form-control-md"
                                        style={{ textAlign: 'right', width: '50%' }}
                                        value={adjustAmount || ""}
                                        onChange={(e) => setAdjustAmount(e.target.value)}
                                        onBlur={(e) => setAdjustAmount(formatCurrency(parseCurrency(e.target.value)))}
                                        onFocus={(e) => setAdjustAmount(parseCurrency(e.target.value))}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer px-4 pb-4 justify-content-center">
                        <button className="btn btn-danger px-4 me-3" onClick={onClose}>ยกเลิก</button>
                        <button className="btn btn-success px-4" onClick={handleSubmit}>
                            บันทึก
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditRemainModal;